import { css } from '@emotion/css'
import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import { CheckboxTableRow, ExTable, FixedFooter, ModalButton, TableBody, TableCell, TableHead, TableWrapper, useMultipleCheckForm } from 'components/shared/widget'
import { useFetchPrintRequestInstitutionsApi } from 'api/institution'
import { Institution } from 'entities/institution'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import { Alert, Button } from 'react-bootstrap'
import { InstitutionViewModel } from 'view_models/institution_view_model'
import { usePostSendHistoryApi } from 'api/send_history'
import { SendHistoryForm } from 'entities/send_history'
import { useEffectSkipFirst, useForm } from 'utils/hooks'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { sampleColumnInfoList, SampleTableData } from 'components/sample/sample_table'
import { Sample, SampleSearchForm } from 'entities/sample'
import { useFetchProductItemsApi } from 'api/product_item'
import { ProductItemSearchForm } from 'entities/product_item'
import { useFetchSamplesApi } from 'api/sample'
import { Pagination } from 'components/shared/pagination'

type Props = {
    history: H.History
}

const PrintRequestsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const api = useFetchPrintRequestInstitutionsApi()
    const multipleCheckForm = useMultipleCheckForm<Institution>()
    const sendHistoryForm = useForm<SendHistoryForm>({})
    const postSendHistoryApi = usePostSendHistoryApi()

    useEffect(() => {
        api.execute()
    }, [])

    useEffectSkipFirst(() => {
        sendHistoryForm.updateObject(
            'institutionIds',
            multipleCheckForm.form.object.items.map((i) => i.id)
        )
    }, [multipleCheckForm.form.object.items])

    useEffectSkipFirst(() => {
        globalState.setLoading(postSendHistoryApi.loading)
        if (postSendHistoryApi.isSuccess()) {
            props.history.push('/send_histories')
        }
    }, [postSendHistoryApi.loading])

    const productForm = useForm<ProductItemSearchForm>({ scope: 'all' })
    const productApi = useFetchProductItemsApi(productForm)
    const searchForm = useForm<SampleSearchForm>({ ordering: 'sample_created_at', sampleStatus: 'COMPLETED' })
    const sampleDisplaySetting = useDisplaySetting(
        sampleColumnInfoList(
            searchForm,
            productApi.response.results.map((pi) => {
                return { label: pi.name, value: pi.id! }
            })
        ),
        'Sample'
    )
    const sampleApi = useFetchSamplesApi(searchForm)

    useEffect(() => {
        productApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        sampleApi.execute()
    }, [searchForm.object])
    return (
        <>
            <ContentHeader headerTitle="検査済 施設一覧" right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>} />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center"></Flex>
                <Flex alignItems="center">
                    {/* <Pagination pageSet={api.pageSet} response={api.response}></Pagination> */}
                    {/* <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div> */}
                </Flex>
            </Flex>
            <ContentBody>
                <Alert variant="info">
                    病院・クリニックを選択して、結果票を印刷してください
                    {/* <br /> */}
                    （選択した病院はすべて一つの依頼表にまとめられます）
                </Alert>
                <TableWrapper showFooter={multipleCheckForm.form.object.items.length > 0} contentHeaderCount={3}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <TableCell th align="center" width={50}>
                                    ID
                                </TableCell>
                                <TableCell th width={100}>
                                    施設コード
                                </TableCell>
                                <TableCell th width={250}>
                                    施設名
                                </TableCell>
                                <TableCell th width={70} align="center">
                                    検査済
                                </TableCell>
                                <TableCell th minWidth={300}>
                                    住所
                                </TableCell>
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={6}>
                            {api.response.results.map((institution: Institution) => {
                                return (
                                    <CheckboxTableRow key={`institution-${institution.id}`} item={institution} multipleCheckForm={multipleCheckForm}>
                                        <TableCell align="center">{institution.id}</TableCell>
                                        <TableCell>{institution.code}</TableCell>
                                        <TableCell>{institution.name}</TableCell>
                                        <TableCell align="center">
                                            <ModalButton
                                                openButton={<button className={css`
                                                    cursor: pointer;
                                                    border: none;
                                                    background: none;
                                                    color: #0033cc;
                                                    &:hover{
                                                    text-decoration: underline;
                                                    color: #002080;
                                                }`}>{institution.completedSampleCount} 件</button>}
                                                modalProps={{ fullscreen: true }}
                                                handleOpen={() => { searchForm.updateObject('institutionId', institution.id) }}
                                                modalBody={
                                                    <>
                                                        <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                                                            <Flex>
                                                                Samples
                                                            </Flex>
                                                            <Flex alignItems="center">
                                                                <Pagination pageSet={sampleApi.pageSet} response={sampleApi.response}></Pagination>
                                                                <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {sampleApi.response.count.toLocaleString()}件</div>
                                                            </Flex>
                                                        </Flex>
                                                        <ContentBody>
                                                            <TableWrapper contentHeaderCount={2}>
                                                                <ExTable className="sticky-table">
                                                                    <TableHead>
                                                                        <TableHeads displaySetting={sampleDisplaySetting} />
                                                                    </TableHead>
                                                                    <TableBody loading={sampleApi.loading} columnLength={sampleDisplaySetting.getColumnLength() + 1}>
                                                                        {sampleApi.response.results.map((sample: Sample) => {
                                                                            return (
                                                                                <tr key={sample.id}>
                                                                                    <SampleTableData sample={sample} displaySetting={sampleDisplaySetting} />
                                                                                </tr>
                                                                            )
                                                                        })}
                                                                    </TableBody>
                                                                </ExTable>
                                                            </TableWrapper>
                                                        </ContentBody>
                                                    </>
                                                }
                                            />
                                        </TableCell>
                                        <TableCell>{new InstitutionViewModel(institution).addressVm().wholeView()}</TableCell>
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    {/* <Pagination pageSet={api.pageSet} response={api.response}></Pagination> */}
                </TableWrapper>
            </ContentBody>

            <FixedFooter open={multipleCheckForm.form.object.items.length > 0}>
                <Button
                    variant="success"
                    onClick={() => {
                        globalState.showConfirm('選択した施設の特定記録郵便差出表をまとめて作成します。よろしいですか？', () => {
                            postSendHistoryApi.execute(sendHistoryForm)
                        })
                    }}
                >
                    結果票印刷
                </Button>
            </FixedFooter>
        </>
    )
}

export default withRouter(PrintRequestsPage)
